import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = '/catalogos/directorio-de-areas';

/**
 * GET directorio de area
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDirectorioDeAreas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
